function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'01d1b6a38480b397ed487a5eb029ac60': 'rgb(78, 78, 72)','ba1a882375a23130decc0342420c6860': 'rgb(241, 197, 170)','65cb59645b852c2394ba3ff8b295e83c': 'rgb(181, 223, 219)','1483fa4f0ec6e94a8a2530a761fa23f0': 'rgb(68, 68, 68)','b76ba10708485bfe67330a76e91197a1': 'rgb(68, 68, 68)','12284913bfe16bebd8bc809573f0387a': 'rgb(159, 135, 101)','97f014516561ef487ec368d6158eb3f4': 'rgb(217, 217, 217)','8b823f49ba31caa5cd88e520c2f82bdc': 'rgb(181, 223, 219)','5161a384c29d5cd7468ad16944047c8b': 'rgb(248, 216, 221)','3576fa9734a36f3eb732e92745865271': 'rgb(244, 244, 244)','312ee6b77f05b59ee4f528c96e84b50e': 'rgb(68, 68, 68)','810ae656a23de2829c27372eb0f10846': 'rgb(0, 0, 0)','900bc885d7553375aec470198a9514f3': 'rgb(158, 189, 208)','1a95041262543791a653ee4290c3e6af': 'rgb(233, 177, 183)',};

    this.images = {'4a0b0dcedd48f780778d1cd1bb8f9877': 'url("//cadense.com/cdn/shop/files/PinkSwatch_68x.jpg?v=6856117470980427399")','3862d0eebdcfc3df1491dd4f599f7257': 'url("//cadense.com/cdn/shop/files/BlueSwatch_68x.jpg?v=13934390274887980808")','d508fe45cecaf653904a0e774084bb5c': 'url("//cadense.com/cdn/shop/files/WhiteSwatch_68x.jpg?v=10720384159587490533")','1ffd9e753c8054cc61456ac7fac1ac89': 'url("//cadense.com/cdn/shop/files/BlackSwatch_68x.jpg?v=557700156488437809")','312ee6b77f05b59ee4f528c96e84b50e': 'url("//cadense.com/cdn/shop/files/SlateSwatch_68x.jpg?v=8336459559433827212")','5596efe53a58fe58c28c1757ef095b23': 'url("//cadense.com/cdn/shop/files/ChampagneSwatch_68x.jpg?v=7719183484960802656")','019a195c66ec381798ae9b8be6a9ae06': 'url("//cadense.com/cdn/shop/files/ManhattanGreySwatch_68x.jpg?v=1148029404934093977")','5687bbb0df3d7e3b2e5015770aa7f9a6': 'url("//cadense.com/cdn/shop/files/NaturalBlackSwatch_68x.jpg?v=14399796614246975109")','4326f5fa12ca85c921c7d3278cfd68d5': 'url("//cadense.com/cdn/shop/files/GlacierSwatch_68x.jpg?v=16943895805041884228")','f33b6cef64ea236ab146fe3f6c40199c': 'url("//cadense.com/cdn/shop/files/AllBlackSwatch_68x.jpg?v=12708161622339710436")','377feb0100d430c5b9b8e0b6fedd29e3': 'url("//cadense.com/cdn/shop/files/AERIO_GREY_T1_68x.jpg?v=18057971524795300332")','1b908e69c96485706095ed1b37bea00a': 'url("//cadense.com/cdn/shop/files/AERIO_LEMONADE-T1_68x.jpg?v=4999184135104923079")','73f56b845ab31d8b51b4d045636af88b': 'url("//cadense.com/cdn/shop/files/AERIO_Deep-Lagoon-T1_68x.jpg?v=1398487802630065029")',};
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) swatch.style.setProperty('--tick-color', '#000');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      if(swatch.getAttribute('swatch-mf-image') != null){
        swatch.style.setProperty("--background-graphic", swatch.getAttribute('swatch-mf-image'));
      } else {
        swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      }
      swatch.classList.add('is-image');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
